import { getFromLS, saveToLS } from '@vyce/core/src/utils/local-storage';

/**
 * Single source of truth for auth token storage on web.
 * The access token is short-lived; the refresh token is long-lived and rotates
 * on every successful refresh. Both are mirrored in localStorage so the axios
 * request interceptor (and the single-flight refresh) can read them outside React.
 */

export const ACCESS_TOKEN_LS_KEY = 'token';
export const REFRESH_TOKEN_LS_KEY = 'refresh_token';

export const getAccessToken = (): string => getFromLS(ACCESS_TOKEN_LS_KEY) || '';

export const getRefreshToken = (): string => getFromLS(REFRESH_TOKEN_LS_KEY) || '';

export const setTokens = (accessToken: string, refreshToken?: string) => {
  saveToLS(ACCESS_TOKEN_LS_KEY, accessToken);
  if (refreshToken !== undefined) {
    saveToLS(REFRESH_TOKEN_LS_KEY, refreshToken);
  }
};

export const clearTokens = () => {
  saveToLS(ACCESS_TOKEN_LS_KEY, '');
  saveToLS(REFRESH_TOKEN_LS_KEY, '');
};
